module.exports = __webpack_public_path__ + "static/media/play.46f56c41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/play.svg
// module id = 24
// module chunks = 1